﻿/**
 * Site Notice functionality
 *
 */

(function ($) {
    $.fn.rlSiteNotice = function () {

        // Cookie set up
        var currentSiteNoticeCookieId;

        var cookieExists = hasWelcomeCookie();
        if (!cookieExists) {
            currentSiteNoticeCookieId = createUniqueGuid();
        } else {
            currentSiteNoticeCookieId = getCookieGuid();
        }

        // Set cookie with button click
        $('#siteNotice button').on('click', function () {
            setCookie();
        });

        function setCookie() {
            var domain;
            //set expiry
            var expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime());
            expiryDate.setMonth(expiryDate.getMonth() + 3);
            var expires = ";expires=" + expiryDate.toUTCString();

            //set domain
            domain = (location.host.split(".").reverse().splice(0, 2).reverse().join("."));
            domain = domain === "localhost" ? "" : ";domain=." + domain;

            document.cookie = "RlSiteNotice=" + encodeURIComponent(currentSiteNoticeCookieId) + expires + ";path=/" + domain;

        }

        function createUniqueGuid() {
            var newUuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c === "x" ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });

            return newUuid;
        }

        function getCookieGuid() {
            var regex = new RegExp("(?:^|;)\\s?RlSiteNotice=(.*?)(?:;|$)", "i");
            var result = document.cookie.match(regex);

            return (result === null) ? null : unescape(result[1]);
        }

        function hasWelcomeCookie() {
            var regex = new RegExp("(?:^|;)\\s?RLSiteNotice=(.*?)(?:;|$)", "i");
            var result = document.cookie.match(regex);

            if (result === null) {
                return false;
            }
            return true;

        };

        // Accessibility

        /// Set tabindex after OneTrust update and check for OptanonAlertBoxClosed cookie
        $(window).on('OneTrustGroupsUpdated', function () {
            if (typeof OnetrustActiveGroups !== undefined && OnetrustActiveGroups.split(',').indexOf('C0001') !== -1 && document.cookie.indexOf("OptanonAlertBoxClosed=") !== -1 && !cookieExists) {
                $('#siteNotice').modal('show');
                $('#siteNotice').attr('tabindex', '0').focus();
            }
        });

        // Trap focus while modal is active
        const focusableElements = 'button, [href]';
        const modal = document.querySelector('#siteNotice');
        const modalContent = $('.modal-content');

        // First element to be focused
        const firstFocusableElement = modal.querySelectorAll(focusableElements)[0];
        const focusableContent = modal.querySelectorAll(focusableElements);
        // Last element to be focused
        const lastFocusableElement = focusableContent[focusableContent.length - 1];

        modalContent.on('keydown', function (e) {

            var keycode = (e.keyCode ? e.keyCode : e.which);

            if (keycode == 9) {
                if (e.shiftKey) {
                    if (document.activeElement === firstFocusableElement) {
                        lastFocusableElement.focus();
                        e.preventDefault();
                    }
                } else {
                    if (document.activeElement === lastFocusableElement) {
                        firstFocusableElement.focus();
                        e.preventDefault();
                    }
                }
            }
        });

        firstFocusableElement.focus();
    }
}(jQuery));